import IconDelete from "./IconDelete.vue";
export default IconDelete